<template>
  <div class="content-item">
    <div class="setting-item clearFloat">
      <div class="content-item clearFloat verticallyCenter arrange-sets">
        <div class="mr16">
          <div class="verticallyCenter mb16">
            <span class="mr16 fs14">方向</span>
            <div class="autoLayout-directions">
              <el-tooltip class="item" effect="dark" content="纵向排列" placement="top-end" :open-delay="1000">
                <span @click="directionVal = 'vertical'" :class="directionVal === 'vertical' ? 'active' : ''"
                  class="icon-portal-direction-down"></span>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="横向排列" placement="top-end" :open-delay="1000">
                <span @click="directionVal = 'horizon'" :class="directionVal !== 'vertical' ? 'active' : ''"
                  class="icon-portal-direction-right"></span>
              </el-tooltip>
            </div>
          </div>
          <div class="verticallyCenter">
            <span class="mr16 fs14">间距</span>
            <el-input placeholder="0" class="mr16 input-size" :type="marginType === 'px' ? 'number' : ''"
              style="width: 80px; margin-right: 0" v-model="newMarginVal" @focus="getFocus($event)">
              <template slot="suffix">
                <el-dropdown trigger="click" @command="marginTypeHandleCommand">
                  <span class="el-dropdown-link lineHeight32" v-if="marginType !== 'auto'">
                    {{ marginType }}
                  </span>
                  <span class="el-dropdown-link lineHeight32" v-else><i class="icon-portal-arrows-down"></i></span>
                  <el-dropdown-menu slot="dropdown" class="dropdown-size">
                    <el-dropdown-item v-for="(margin, index) in marginTypes" :key="index" :command="margin.value">
                      <span class="selected-icon" :class="marginType === margin.value ? 'icon-portal-check-small' : ''"></span>
                      {{ margin.value !== 'auto' ? rowColMarginVal + 'px' : margin.label }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-input>
          </div>
        </div>
        <div class="align-style-box margin-auto" v-if="marginType === 'auto'">
          <div v-if="directionVal === 'vertical'">
            <div class="align-style-item vertical">
              <el-tooltip class="item" effect="dark" v-for="(item, hIndex) in verticalAutoAlignStyles" :key="hIndex"
                :content="item.label + '对齐'" placement="top-end" :open-delay="1000">
                <span class="align-style" @mouseenter.self.stop="alignStyleMouseenter(item.positionH, hIndex)"
                  @mouseleave.self.stop="alignStyleMouseleave" :class="[
                    alignStyleHover && hIndex === hoverAlignIndex
                      ? 'active icon ' + item.icon
                      : 'default',
                    alignPositionHVal === item.positionH
                      ? 'selected icon ' + item.icon
                      : ''
                  ]" @click="changeAlignStyle(item.positionH, '')"></span>
              </el-tooltip>
            </div>
          </div>
          <div v-if="directionVal === 'horizon'">
            <div class="align-style-item horizon">
              <el-tooltip class="item" effect="dark" v-for="(item, hIndex) in horizonAutoAlignStyles" :key="hIndex"
                :content="item.label + '对齐'" placement="top-end" :open-delay="1000">
                <span class="align-style" @mouseenter.self.stop="alignStyleMouseenter(item.positionV, hIndex)"
                  @mouseleave.self.stop="alignStyleMouseleave" :class="[
                    alignStyleHover && hoverAlignPosition === item.positionV
                      ? 'active icon ' + item.icon
                      : 'default',
                    alignPositionVVal === item.positionV
                      ? 'selected icon ' + item.icon
                      : ''
                  ]" @click="changeAlignStyle('', item.positionV)"></span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="align-style-box" v-else>
          <div v-if="directionVal === 'vertical'">
            <div class="align-style-item" v-for="(position, index) in positions.vertical" :key="'position_' + index">
              <el-tooltip class="item" effect="dark" v-for="(item, hIndex) in alignStyles" :key="hIndex"
                :content="position.label + item.label + '对齐'" placement="top-end" :open-delay="1000">
                <span class="align-style" @mouseenter.self.stop="alignStyleMouseenter(position.value, hIndex)"
                  @mouseleave.self.stop="alignStyleMouseleave" :class="[
                    alignStyleHover && hoverAlignPosition === position.value && hIndex === hoverAlignIndex
                      ? 'active icon ' + item.icon
                      : 'default',
                    alignPositionHVal === item.positionH && alignPositionVVal === position.value
                      ? 'selected icon ' + item.icon
                      : ''
                  ]" @click="changeAlignStyle(item.positionH, position.value)"></span>
              </el-tooltip>
            </div>
          </div>
          <div v-if="directionVal === 'horizon'">
            <div class="align-style-item" v-for="(item, index) in alignStyles" :key="'position_' + index">
              <el-tooltip class="item" effect="dark" v-for="(position, hIndex) in positions.horizon" :key="hIndex"
                :content="item.label + position.label + '对齐'" placement="top-end" :open-delay="1000">
                <span class="align-style" @mouseenter.self.stop="alignStyleMouseenter(position.value, index)"
                  @mouseleave.self.stop="alignStyleMouseleave" :class="[
                    alignStyleHover && hoverAlignPosition === position.value && index === hoverAlignIndex
                      ? 'active icon ' + item.icon
                      : 'default',
                    alignPositionHVal === position.value && alignPositionVVal === item.positionV
                      ? 'selected icon ' + item.icon
                      : ''
                  ]" @click="changeAlignStyle(position.value, item.positionV)"></span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cx-check-box :value.sync="autoWrapVal" class="mt12">自动换行</cx-check-box>
    <div class="verticallyCenter mt12" v-if="autoWrapVal">
      <span class="mr16 fs14" v-if="directionVal === 'horizon'">下间距</span>
      <span class="mr16 fs14" v-else>右间距</span>
      <el-input placeholder="0" class="mr16" type="number" style="width: 88px; margin-right: 0"
        v-inputHandle="{ this1, type: 'rowColMarginRightVal' }" v-model="rowColMarginRightVal" @focus="getFocus($event)">
        <template slot="suffix">
          <span class="suffix_text">px</span>
        </template>
      </el-input>
    </div>
  </div>
</template>

<script>
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    },
    elementOptions: {
      type: Array
    }
  },
  data() {
    return {
      this1: this,
      positions: {
        horizon: [
          {
            value: "left",
            label: "左"
          },
          {
            value: "center",
            label: "居中"
          },
          {
            value: "right",
            label: "右"
          }
        ],
        vertical: [
          {
            value: "top",
            label: "顶部"
          },
          {
            value: "middle",
            label: ""
          },
          {
            value: "bottom",
            label: "底部"
          }
        ]
      },
      alignStyleHover: false,
      hoverAlignPosition: null,
      hoverAlignIndex: null,
      verticalAlignStyles: [
        {
          label: "左",
          icon: "icon-portal-h-left",
          positionH: "left"
        },
        {
          label: "居中",
          icon: "icon-portal-h-center",
          positionH: "center"
        },
        {
          label: "右",
          icon: "icon-portal-h-right",
          positionH: "right"
        }
      ],
      horizonAlignStyles: [
        {
          label: "顶部",
          icon: "icon-portal-v-top",
          positionV: "top"
        },
        {
          label: "",
          icon: "icon-portal-v-middle",
          positionV: "middle"
        },
        {
          label: "底部",
          icon: "icon-portal-v-bottom",
          positionV: "bottom"
        }
      ],
      marginTypes: [
        {
          value: "px",
          label: "px"
        },
        {
          value: "auto",
          label: "自动"
        },
      ],
      verticalAutoAlignStyles: [
        {
          label: "左",
          icon: "icon-portal-auto-v-top",
          positionH: "left"
        },
        {
          label: "居中",
          icon: "icon-portal-auto-v-center",
          positionH: "center"
        },
        {
          label: "右",
          icon: "icon-portal-auto-v-bottom",
          positionH: "right"
        }
      ],
      horizonAutoAlignStyles: [
        {
          label: "顶",
          icon: "icon-portal-auto-v-top",
          positionV: "top"
        },
        {
          label: "居中",
          icon: "icon-portal-auto-v-center",
          positionV: "middle"
        },
        {
          label: "底",
          icon: "icon-portal-auto-v-bottom",
          positionV: "bottom"
        }
      ],
    }
  },
  computed: {
    showAutoLayoutVal: {
      get() {
        return this.options?.hasOwnProperty("showAutoLayoutVal") ? this.options.showAutoLayoutVal : "false"
      },
      set(newVal) {
        this.$emit("update", "showRowColLayout", newVal)
      }
    },
    directionVal: {
      get() {
        return this.options?.hasOwnProperty("rowColDirection") ? this.options.rowColDirection : "vertical"
      },
      set(newVal) {
        if (newVal === this.directionVal) return
        this.$emit("update", "rowColDirection", newVal)
      }
    },
    newMarginVal: {
      get() {
        if (this.marginType !== "auto") return this.rowColMarginVal
        else return "自动"
      },
      set(newVal) {
        if (this.marginType !== "auto") {
          this.rowColMarginVal = newVal
        }
      }
    },
    rowColMarginVal: {
      get() {
        return this.options?.hasOwnProperty("rowColMargin") ? this.options.rowColMargin : 0
      },
      set(newVal) {
        if (newVal === this.rowColMarginVal) return
        newVal = newVal < 0 || !newVal ? 0 : newVal
        this.$emit("update", "rowColMargin", newVal)
      }
    },
    autoWrapVal: {
      get() {
        return this.options?.hasOwnProperty("autoWrap") ? this.options.autoWrap : false
      },
      set(newVal) {
        this.$emit("update", "autoWrap", newVal)
      }
    },
    rowColMarginRightVal: {
      get() {
        return this.options?.hasOwnProperty("rowColMarginRight") ? this.options.rowColMarginRight : 0
      },
      set(newVal) {
        if (newVal === this.rowColMarginRightVal) return
        newVal = newVal < 0 || !newVal ? 0 : newVal
        this.$emit("update", "rowColMarginRight", newVal)
      }
    },
    alignPositionHVal: {
      get() {
        return this.options?.hasOwnProperty("rowColAlignPositionH") ? this.options.rowColAlignPositionH : "left"
      },
      set(newVal) {
        if (newVal === this.alignPositionHVal) return
        this.$emit("update", "rowColAlignPositionH", newVal)
      }
    },
    alignPositionVVal: {
      get() {
        return this.options?.hasOwnProperty("rowColAlignPositionV") ? this.options.rowColAlignPositionV : "top"
      },
      set(newVal) {
        if (newVal === this.alignPositionVVal) return
        this.$emit("update", "rowColAlignPositionV", newVal)
      }
    },
    alignStyles() {
      return this.directionVal === "vertical" ? this.verticalAlignStyles : this.horizonAlignStyles
    },
    elementOptionsVal: {
      get() {
        return this.elementOptions || []
      },
      set(newVal) {
        this.$emit("update", "elementOptions", newVal)
      }
    },
    marginType: {
      get() {
        return this.options?.hasOwnProperty("marginType") ? this.options.marginType : "px"
      },
      set(newVal) {
        this.$emit("update", "marginType", newVal)
      }
    },
  },
  methods: {
    getFocus(event) {
      event.currentTarget.select()
    },
    alignStyleMouseenter(poition, index) {
      this.alignStyleHover = true
      this.hoverAlignPosition = poition
      this.hoverAlignIndex = index
    },
    alignStyleMouseleave() {
      this.alignStyleHover = false
      this.hoverAlignPosition = null
      this.hoverAlignIndex = null
    },
    changeAlignStyle(positionH, positionV) {
      if (positionH) {
        this.alignPositionHVal = positionH
      }
      if (positionV) {
        this.alignPositionVVal = positionV
      }
    },
    // 重新计算组件的位置
    reComputePosition(val) {
      if (val) {
        this.elementOptionsVal.forEach((item, index) => {
          this.$set(item, "isNoConflictCheck", true)
        })
        return
      }
      let col = document.getElementById(`componentBox_after${this.ids.uid}`)
      let autoLayoutBox = col.getElementsByClassName("auto-layout-container")[0]
      let elements = autoLayoutBox.getElementsByClassName("vdr")
      let top = autoLayoutBox.offsetTop,
        left = autoLayoutBox.offsetLeft
      if (this.alignPositionVVal === "middle") {
        top = col.clientHeight / 2 - autoLayoutBox.clientHeight / 2
      }
      if (this.alignPositionHVal === "center") {
        left = col.clientWidth / 2 - autoLayoutBox.clientWidth / 2
      }
      this.elementOptionsVal.forEach((item, index) => {
        let itemTop = elements[index].offsetTop + top
        let itemLeft = elements[index].offsetLeft + left
        delete item.isNoConflictCheck
        this.$set(item, "top", itemTop)
        this.$set(item, "left", itemLeft)
      })
    },
    marginTypeHandleCommand(command) {
      console.log('command :>>', command);
      this.marginType = command
      if (command === "auto") {
        this.newMarginVal = "自动"
      }
    },
  }
})
</script>
<style scoped>
.arrange-sets {
  justify-content: space-between;
  font-size: 0;
}

.autoLayout-directions {
  background-color: var(--inputBackGround);
  border-radius: 3px;
  padding: 2px;
  color: var(--iconColor);
}

.autoLayout-directions span {
  display: inline-block;
  line-height: 28px;
  width: 38px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
}

.autoLayout-directions span.active {
  color: var(--themeColor);
  background-color: #FFFFFF;
  border-radius: 3px;
}

.align-style-box {
  width: 80px;
  height: 80px;
  padding: 4px;
  box-sizing: border-box;
  border: 1px solid var(--messageTipsBorderColor);
  border-radius: 4px;
  background-color: var(--leftMenuBgColor);
}

.align-style {
  position: relative;
  display: inline-block;
  cursor: pointer;
  font-size: 20px;
}

.align-style.icon:hover:before {
  color: var(--themeColorDisabled);
}

.align-style.icon.selected:before {
  color: var(--themeColor);
}

.align-style.default:not(.selected):before {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 2px;
  content: "";
  background-color: var(--iconColor);
  transform: translate(-50%, -50%);
}

.align-style-item {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.align-style-item span {
  display: inline-block;
  line-height: 20px;
  height: 20px;
  width: 20px;
  margin: 2px;
}

.margin-auto .align-style-item {
  height: 72px;
}

.margin-auto .align-style-item span:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.align-style-item.vertical span {
  /* height: 100%; */
  transform: rotate(-90deg);
}

.align-style-item.horizon {
  flex-direction: column;
}

.align-style-item.horizon span {
  display: block;
  width: 100%;
}

::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}

::v-deep .input-size .el-input__suffix {
  right: 4px;
}

::v-deep .input-size .el-dropdown-link {
  display: block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}

::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}

::v-deep .input-size.el-input.is-disabled .el-input__inner {
  background: var(--inputBackGround) !important;
}

.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}

.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 90px;
  padding-left: 36px;
  padding-right: 12px;
}

.el-dropdown-menu__item {
  color: var(--textColor);
  font-size: 13px;
}
</style>
